import { Loader } from "@mantine/core";
import AdminSupplierCostingPreview from "pages/admin/suppliers/AdminSupplierCostingPreview";
// import PreviewHeader from "components/header/PreviewHeader";
import { useSearchParams } from "react-router-dom";

type PreviewType = "costing" | "prices";
const PrintSupplierOrder: React.FC = () => {
  const [params] = useSearchParams();
  const id = params.get("id");
  const raw = params.get("t");

  if (!id) return <Loader />;

  const previewType = raw === "costing" || raw === "prices" ? raw : "prices";

  return (
    <div className="inner-container">
      {/* <PreviewHeader /> */}
      <AdminSupplierCostingPreview previewType={previewType} id={Number(id)} />
    </div>
  );
};

export default PrintSupplierOrder;
